import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { type PackageFormType, store } from "../../_store";
import { errorHandler } from "../../_utils";
import { setPackageLoading, setPackages } from "../slices/packageSlice";

export const getPackages = async (notify: MessageInstance) => {
  try {
    store.dispatch(setPackageLoading(true));
    const response = await privateAPI.get("/packages");
    if (response) {
      store.dispatch(setPackageLoading(false));
      store.dispatch(setPackages(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setPackageLoading(false));
    errorHandler(error, notify);
    console.error("Get Packages Error:", error);
  }
};

export const createPackage = async (
  notify: MessageInstance,
  payload: PackageFormType,
) => {
  try {
    store.dispatch(setPackageLoading(true));
    const { data } = await privateAPI.post("/packages", payload);
    notify.success("Package created successfully!");
    return data;
  } catch (error) {
    errorHandler(error, notify);
    console.error("Create Package Error:", error);
  } finally {
    store.dispatch(setPackageLoading(false));
  }
};

export const updatePackage = async (
  notify: MessageInstance,
  payload: PackageFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setPackageLoading(true));
    const { data } = await privateAPI.patch(`/packages/${payload.id}`, payload);
    notify.success("Package updated successfully!");
    return data;
  } catch (error) {
    errorHandler(error, notify);
    console.error("Update Package Error:", error);
  } finally {
    store.dispatch(setPackageLoading(false));
  }
};

export const deletePackage = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setPackageLoading(true));
    const response = await privateAPI.delete(`/packages/${id}`);
    if (response) {
      getData && (await getPackages(notify));
    }
    notify.success("Package deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Package Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setPackageLoading(false));
  }
};
